const setup = () => {
  const items = document.querySelectorAll('[data-w-variation-selector]');

  items.forEach((item) => {
    const form = item.querySelector('form[data-w-variation-selector-choices]');
    const images = item.querySelectorAll('img');
    const radios = item.querySelectorAll('input[type="radio"]');
    const toggles = item.querySelectorAll('[data-w-variation-selector-toggle]');
    const groups = item.querySelectorAll(
      '[data-w-variation-selector-choice-group]'
    );

    toggles.forEach((toggle) => {
      toggle.addEventListener('click', () => {
        item.classList.toggle('w-is-open');
      });
    });

    radios.forEach((radio) => {
      radio.addEventListener('submit', (e) => {
        e.preventDefault();

        return false;
      });
      radio.addEventListener('change', (e) => {
        e.preventDefault();

        const formData = new FormData(form);
        const values = {};
        for (const key of new Set(formData.keys())) {
          const all = formData.getAll(key);
          values[key] = all.length > 1 ? all : all[0];
        }

        const image = item.querySelector(
          "img[data-variation='" + JSON.stringify(values) + "']"
        );
        images.forEach((img) => {
          img.classList.remove('w-is-active');
        });
        image.classList.add('w-is-active');
      });
    });

    groups.forEach((group) => {
      const groupType = group.dataset.wVariationSelectorChoiceGroupType;
      const groupToggle = group.querySelector('button');

      groupToggle.addEventListener('click', (e) => {
        e.preventDefault();

        if (groupType !== 'color') {
          const radios = group.querySelectorAll('input[type="radio"]');
          const checkedRadio = group.querySelector(
            'input[type="radio"]:checked'
          );
          const currentIndex = Array.from(radios).indexOf(checkedRadio);
          const nextIndex = (currentIndex + 1) % radios.length;
          radios[nextIndex].checked = true;
          radios[nextIndex].dispatchEvent(
            new Event('change', { bubbles: true })
          );
        } else {
          group.classList.toggle('w-is-spread');
        }
      });
    });
  });
};

export default function VariationSelector() {
  return {
    init: () => {
      setup();
    },
  };
}
